export default {
  common: {
    loading: '読み込み中',
    confirm: '確認',
    cancel: 'キャンセル',
    save: '保存',
    back: '戻る',
    copy: 'コピー',
    delete: '削除',
    copySuccess: 'コピーしました',
    editSuccess: '編集成功',
    deleteSuccess: '削除成功',
    modifySuccess: '更新成功',
    cannotBeEmpty: '必須項目です',
    noContent: 'コンテンツがありません',
    noData: '関連データがありません',
    noMoreData: 'これ以上のデータはありません',
    iKnow: '了解しました',
    selectService: 'サービスプロバイダーを選択',
    sendSuccess: '送信成功',
  },
  billHome: {
    recharge: 'チャージ・支払い',
    coupon: 'クーポン',
    rechargeNow: '今すぐチャージ',
    cost: '通話料',
    flow: 'データ通信量',
    rechargeNotice: 'チャージ前に確認',
    rechargeCost: '通話料チャージ',
    rechargeFlow: 'データチャージ',
    rechargeAmount: 'チャージ金額',
    rechargePackage: 'チャージプラン',
    discount: '割引適用',
    confirmTxt: '確認しました',
    confirmTxt1: '了解です',
    actualPayment: 'お支払い金額',
    selectCoupon: 'クーポンを選択',
    useRule: '利用規約',
    availableCoupon: '利用可能なクーポン',
    unavailableCoupon: '利用不可のクーポン',
    noAvailableCoupon: '利用可能なクーポンはありません',
    selectPhone: '電話番号を選択',
    pleaseInputPhone: '電話番号入力',
    couponCount: '枚利用可能',
    pleaseInputCorrectPhone: '正しい電話番号を入力してください',
    pleaseSelectPackage: 'チャージプランを選択してください',
  },
  accountManage: {
    title: 'アカウント管理',
    edit: '編集',
    deleteConfirm: '削除してもよろしいですか？',
  },
  rechargeDetail: {
    title: '支払い詳細',
    continuePay: '支払いを続ける',
  },
  feesExpense: {
    title: '支払い履歴',
    recharge: '携帯料金',
    electricity: '電気代',
    internet: 'ネット料金写',
    water: '水道代',
    photo: '撮影',
    complete: '完了',
    manage: '管理',
    allSelect: 'すべて選択',
    selected: '選択済み',
    deleteConfirm: '次の',
    deleteRecord: '支払い記録を削除しますか？',
    noDataAction: '操作可能なデータはありません',
    pleaseSelect: '削除する記録を選択してください',
    feesNotice: '支払いの注意事項',
  },
  formCom: {
    upload: 'アップロード',
    saveAccount: 'アカウントを保存または更新',
    createOrder: '注文を作成',
    rechargeIng: 'チャージ中',
    rechargeNow: '今すぐチャージ',
    serviceProvider: 'プロバイダー',
    billImage: '請求書の画像',
    returnSelect: '戻って再選択',
    electricity: '電気料金',
    internet: 'インターネット料金',
    water: '水道料金',
    photo: '写真で支払い',
    life: '生活料金',
    uploadFail: 'アップロードに失敗しました。再試行してください。',
    pleaseFill: 'すべての項目を入力してください',
    submitSuccess: '送信しました。支払いをお待ちください',
  },
  langPop: {
    selectLang: '言語を選択',
  },
  loginPop: {
    loginOrRegister: 'Kuaiziアカウントでログインまたは登録',
    confirmLogout: 'ログアウトしてもよろしいですか？',
    toLogin: 'ログイン',
    logoutSuccess: 'ログアウトしました',
  },
  newMe: {
    myOrder: '注文履歴',
    coupon: 'クーポン',
    accountManage: 'アカウント管理',
    orderCount: '件の注文が進行中',
    couponCount: '枚',
    account: 'アカウント',
    logout: 'ログアウト',
  },
  coupons: {
    all: 'すべて',
    coupon: 'クーポン',
    historyCoupon: '使用済み/期限切れ',
    use: '使う',
    validityPeriod: '有効期限',
    useRule: '利用規約',
    used: '使用済み',
    expired: '期限切れ',
  },
  accountSeting: {
    title: '設定',
    personalInfo: '個人情報',
    modifyPayPassword: '支払いパスワードを変更',
    modifyLoginPassword: 'ログインパスワードを変更',
    phone: '電話番号',
    code: '認証コード',
    loginPassword: 'ログインパスワード',
    confirmModify: '変更を確認',
    noCode: 'コードが届きませんか？',
    passwordPlaceholder: '8～16文字の英数字で入力',
    inputCorrectPhone: '正しい電話番号を入力してください',
    afterGetCode: '後に再取得可能',
    getCode: 'コードを取得',
    input6DigitPassword: '6桁のパスワードを入力してください',
    twoInputPasswordNotConsistent: '2回の入力が一致しません',
    placeholderCode: '認証コードを入力',
    confirmPassword: 'パスワード確認',
    password: 'パスワード',
    submit: '送信',
    avatar: 'プロフィール画像',
    userName: 'ユーザー名',
    nickName: 'ニックネーム',
    modifyPhone: '電話番号を変更',
    nickNamePlaceholder: '個性を表現しましょう',
    sex: '性別',
    male: '男性',
    female: '女性',
    email: 'メールアドレス',
    emailPlaceholder: 'パスワード再設定のためにメールを設定',
    pleaseCompletePersonalData: 'プロフィールを完成させて、より多くの機能を体験しましょう',
    bindNewPhone: '新しい電話番号を登録',
    oldPhone: '旧電話番号',
    completeVerification: '認証を完了',
    changePayPasswordTitle: '支払パスワードを変更',
    changePasswordTitle: 'パスワードを変更',
    oldPhoneTitle: '旧電話番号を確認',
    editInfoTitle: 'プロフィール編集',
    areaCode: '市外局番',
  },
}
